export default function TechnicalDetails() {
  const specifications = [
    {
      category: 'Dimensions',
      specs: [
        { label: 'Length', value: '6-8 meters' },
        { label: 'Width', value: '3-4 meters' },
        { label: 'Height', value: '3-3.5 meters' },
        { label: 'Interior Space', value: '15-25 ㎡' }
      ]
    },
    {
      category: 'Structure',
      specs: [
        { label: 'Frame', value: 'Galvanized steel' },
        { label: 'Exterior', value: 'Aluminium composite' },
        { label: 'Windows', value: 'Tempered curved glass' },
        { label: 'Insulation', value: 'Polyurethane foam' }
      ]
    },
    {
      category: 'Systems',
      specs: [
        { label: 'HVAC', value: 'Smart climate control' },
        { label: 'Electrical', value: '220V/110V compatible' },
        { label: 'Plumbing', value: 'Full bathroom system' },
        { label: 'Solar', value: 'Optional solar panels' }
      ]
    },
    {
      category: 'Capacity',
      specs: [
        { label: 'Occupancy', value: '2-4 persons' },
        { label: 'Bedroom', value: '1 queen bed' },
        { label: 'Bathroom', value: 'Full facilities' },
        { label: 'Weight', value: '3-5 tons' }
      ]
    }
  ];

  return (
    <section className="relative py-24 lg:py-32 bg-gradient-to-b from-transparent via-gray-900/30 to-transparent w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        {/* Section Header */}
        <div className="text-center mb-16 lg:mb-20">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-thin mb-6">
            Technical <span className="text-cyan-400">Specifications</span>
          </h2>
          <p className="text-lg sm:text-xl text-gray-400 max-w-3xl mx-auto">
            Engineered for durability, comfort, and long-term performance
          </p>
        </div>

        {/* Specifications Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {specifications.map((section, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-900/80 to-gray-800/50 border border-cyan-500/30 rounded-3xl p-8"
            >
              <h3 className="text-2xl font-medium mb-6 text-cyan-400">{section.category}</h3>
              <div className="space-y-4">
                {section.specs.map((spec, idx) => (
                  <div key={idx} className="flex justify-between items-center pb-4 border-b border-gray-700/50 last:border-0">
                    <span className="text-gray-400">{spec.label}</span>
                    <span className="text-white font-medium">{spec.value}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Certifications */}
        <div className="mt-16 bg-gradient-to-br from-cyan-500/10 to-transparent border border-cyan-500/30 rounded-3xl p-8 lg:p-12">
          <h3 className="text-2xl font-medium mb-8 text-center">Certifications & Standards</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-cyan-500/20 rounded-2xl flex items-center justify-center mx-auto mb-3">
                <i className="ri-shield-check-line text-3xl text-cyan-400"></i>
              </div>
              <p className="text-sm text-gray-300">ISO 9001</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-cyan-500/20 rounded-2xl flex items-center justify-center mx-auto mb-3">
                <i className="ri-leaf-line text-3xl text-cyan-400"></i>
              </div>
              <p className="text-sm text-gray-300">Green Building</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-cyan-500/20 rounded-2xl flex items-center justify-center mx-auto mb-3">
                <i className="ri-fire-line text-3xl text-cyan-400"></i>
              </div>
              <p className="text-sm text-gray-300">Fire Safety</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-cyan-500/20 rounded-2xl flex items-center justify-center mx-auto mb-3">
                <i className="ri-building-line text-3xl text-cyan-400"></i>
              </div>
              <p className="text-sm text-gray-300">Building Code</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}